const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  if (window.location.hostname === 'localhost') {
    return 'http://localhost:5137';
  }

  return '';
};

export const API_BASE_URL = getApiBaseUrl();

export const apiUrl = (path) => `${API_BASE_URL}${path}`;
